import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import { Content, EstimatedTimeOfUse, ExplanatoryNotes, LARGE_ITEM_SIZE, SuggestedQuantity, Unit } from "./_fields";

type DemandForSupplyTemplate = {
  Content: string;
  Unit: string;
  SuggestedQuantity: string;
  EstimatedTimeOfUse: string;
  Notes: string;
};

export const demandForSupplyTemplate: TemplatesValue<DemandForSupplyTemplate> = {
  fileName: "DanhSachNhuCauCapVatTu",
  sheet: DEFAULT_SHEET_NAME,
  structures: [
    Content,
    {
      ...Unit,
      header: "Đơn vị tính",
      itemSize: LARGE_ITEM_SIZE,
    },
    SuggestedQuantity,
    EstimatedTimeOfUse,
    ExplanatoryNotes,
  ],
  fields: ["Content", "Unit", "SuggestedQuantity", "EstimatedTimeOfUse", "Notes"],
};
